import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from '../redux/store';
// Define a type for the slice state

interface CounterState {
  employeeId: string;
}

// Define the initial state using that type
const initialState: CounterState = {
  employeeId: '',
};
export const employeeIdSlice = createSlice({
  name: 'employeeId',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setEmployeeId: (state, action: PayloadAction<string>) => {
      //console.log('payload is ', action.payload);
      state.employeeId = action.payload;
    },
  },
});

export const {setEmployeeId} = employeeIdSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const employeeIdData = (state: RootState): string =>
  state.employeeIdSlice.employeeId;

//export type State = ReturnType<typeof >;

export default employeeIdSlice.reducer;
